// extracted by mini-css-extract-plugin
export default {"carouselSection":"PopularMovies_carouselSection__331Ge","wrapper":"PopularMovies_wrapper__UlhnH","carouselTitle":"PopularMovies_carouselTitle__mpOTT"};